import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import UsModalStore from './store';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const UsModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  // 关注微信管家
  const renderWeChatManager = () => {
    return (
      <div className={styles.xuniBox}>
        <div className={styles.wxgj_title} />
        <div className={styles.wxgj_tips} />
        <div className={styles.code_bg}>
          <img src={require('./images/gj-code.png')} alt="二维码" />
        </div>
      </div>
    );
  };

  // 关注微信公众号
  // 任务2
  const renderWeChatOfficialAccount = () => {
    return (
      <div className={styles.xuniBox}>
        <div className={styles.wxgzh_title} />
        <div className={styles.wxgzh_tips} />
        <div className={styles.code_bg}>
          <img src={require('./images/wx-code.png')} alt="二维码" />
        </div>
      </div>
    );
  };

  const dyCode = () => {
    return (
      <div className={styles.xuniBox}>
        <div className={styles.dy_title} />
        <div className={styles.dy_tips} />
        {/* <div className={styles.txt_title}>扫码关注抖音</div> */}
        <div className={styles.code_bg}>
          <img src={require('./images/douyin-code.png')} alt="二维码" />
          {/* <div className={styles.codeMengCheng} /> */}
        </div>
      </div>
    );
  };

  const weiboCode = () => {
    return (
      <div className={styles.xuniBox}>
        <div className={styles.wb_title} />
        <div className={styles.wb_tips} />
        {/* <div className={styles.txt_title}>扫码关注微博</div> */}
        <div className={styles.code_bg}>
          <img src={require('./images/weibo-code.png')} alt="二维码" />
          {/* <div className={styles.codeMengCheng} /> */}
        </div>
      </div>
    );
  };

  const tiebaCode = () => {
    return (
      <div className={styles.xuniBox}>
        <div className={styles.tb_title} />
        <div className={styles.tb_tips} />
        {/* <div className={styles.txt_title}>扫码关注抖音</div> */}
        <div className={styles.code_bg}>
          <img src={require('./images/tieba-code.png')} alt="二维码" />
          {/* <div className={styles.codeMengCheng} /> */}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (store.modalType === 1) {
      return renderWeChatManager();
    } else if (store.modalType === 2) {
      return renderWeChatOfficialAccount();
    } else if (store.modalType === 3) {
      return dyCode();
    } else if (store.modalType === 4) {
      return tiebaCode();
    } else if (store.modalType === 5) {
      return weiboCode();
    }
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.bg, store.modalType === 4 && styles.bg2)}>
        <Link
          className={styles.closeBtn}
          onClick={() => {
            store.onClickClose(store.modalType);
          }}
        />
        <div className={styles.content}>{renderContent()}</div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(UsModal, UsModalStore);
